import Lottie from "react-lottie";
import lottie_404 from "../../assets/lottie/404_page.json";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
    const navigate = useNavigate();

    //   const goBack = () => navigate(-1);

    const lottieOptions = {
        loop: true,
        animationData: lottie_404,
    };

    return (
        <section>
            <div className="container">
                <div className="flex w-full items-center justify-between">
                    <div className="w-3/5">
                        <Lottie options={lottieOptions} height={700} />
                    </div>
                    <div className="w-2/5  items-start text-start">
                        <label className="block mb-8 text-4xl text-gray-400 font-medium">죄송합니다!</label>
                        <span className="block text-lg text-gray-700 font-normal">
                            이 페이지에 접근할 수 있는 권한이 없습니다. <br />
                            자세한 내용은 관리자에게 문의해 주세요.
                        </span>
                        <button
                            type="button"
                            className="rounded-lg  mt-4 bg-blue-700 px-3 py-2 text-base font-semibold text-white shadow-xs ring-1 ring-blue-700 ring-inset hover:bg-blue-500"
                            onClick={() => navigate("/")}
                        >
                            로그인 페이지로 돌아가기
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Unauthorized;
